import React from 'react';
import {DEFAULT_ICON,safeIconPath} from './BrowserIdentity';

export default function AppIcon({iconPath,size=36}:{iconPath?:string|null;size?:number}):React.ReactElement {
  const source=safeIconPath(iconPath);
  const [failed,setFailed]=React.useState(false);
  React.useEffect(()=>setFailed(false),[source]);
  return <img src={failed?DEFAULT_ICON:source} alt="" width={size} height={size} style={{width:size,height:size,objectFit:'contain',flexShrink:0,borderRadius:6}} onError={()=>{if(!failed)setFailed(true);}}/>;
}
